const assetUrl = "http://localhost:3001";
const constant = {
  assetUrl: assetUrl,
  assetImageUrl: assetUrl + "/images",
};

export default constant;
